import { XMarkIcon } from "@heroicons/react/20/solid";
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { Actions as FSSREPORTACTIONS } from "../../store/actions/fssReportActions";
import Spinner from "../common/Spinner";

const ConfirmModal = ({
	modalStatus,
	closeModal,
	year,
	validated,
	loading,
	loggedIn,
	credentials,
	errors,
	submitting,
	openFS7ValidationModal,
	submitFS7,
	forFSSExpress,
}) => {
	if (!modalStatus) return null;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div className="modal-dialog" style={{ width: errors ? "70vw" : "50vw"}}>
				<div className="modal-content">
					<div className="block block-themed block-transparent remove-margin-b">
						<div className="block-header bg-primary-dark">
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">
								{year} FS7 {submitting ? "Submission" : "Validation"}
							</h3>
						</div>
					</div>
				</div>
				<div className="modal-body bg-white">
					<div className="col-xs-12">
						{loading ? (
							<>
								<div
									className="col-xs-12"
									style={{ marginBottom: "2rem" }}
								>
									<h4 style={{ textAlign: "center" }}>
										{submitting ? "Submitting" : "Validating"}...
									</h4>
								</div>
								<div
									className="col-xs-12"
									style={{ textAlign: "center" }}
								>
									<Spinner
										style={{ width: "4rem", height: "4rem", verticalAlign: "middle" }}
										className="animate-spin -ml-1 mr-3 h-5 w-5 text-success"
									/>
								</div>
							</>
						) : null}
						{errors && !loading ? (
							<>
								<div
									className="form-section"
									style={{ paddingBottom: "1rem" }}
								>
									<div className="col-xs-12">
										<h4>Errors During Validation:</h4>
									</div>
									<div className="clearfix"></div>
									<div
										style={{
											marginTop: "1rem",
											marginBottom: "1.5rem",
											padding: "1rem",
											borderRadius: "1rem",
											marginLeft: "1rem",
											marginRight: "1rem",
											background: "white",
										}}
									>
										<div
											style={{
												padding: "1rem",
												display: "grid",
												gridGap: "1.5rem",
												grid: "1.5rem",
												gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
											}}
										>
											<div style={{ gridColumn: "span 1 / span 6" }}>
												<h5>Type - Row</h5>
											</div>
											<div style={{ gridColumn: "span 2 / span 6" }}>
												<h5>Employee</h5>
											</div>
											<div style={{ gridColumn: "span 3 / span 6" }}>
												<h5>Description</h5>
											</div>
											{errors?.map((item) => {
												return (
													<>
														<div style={{ gridColumn: "span 1 / span 6" }}>
															<h5>{item.type} - Row {item.row}</h5>
														</div>
														<div style={{ gridColumn: "span 2 / span 6" }}>
															{item.employeeRef} - {item.employeeSurname}
														</div>
														<div style={{ gridColumn: "span 3 / span 6" }}>
															{_.unescape(item.description)
																.replaceAll("<>", "is not equal to")
																.replaceAll("aternirty", "aternity")}
														</div>
													</>
												);
											})}
										</div>
									</div>
								</div>
								{!forFSSExpress ? (
									<div style={{ display: "flex", justifyContent: "center" }}>
										<button
											className="btn btn-default"
											onClick={() => openFS7ValidationModal(year, credentials)}
											disabled={!loggedIn}
											style={{ marginRight: 5 }}
										>
											Validate FS7
										</button>
									</div>
								) : null}
								<div className="clearfix"></div>
							</>
						) : null}
						{validated && !loading && !submitting ? (
							<>
								<h4>All Set!</h4>
								<p>You can proceed to Submit your FS7!</p>
								<div style={{ display: "flex", justifyContent: "center" }}>
									<button
										className="btn btn-success"
										onClick={() => submitFS7(year, credentials)}
										style={{ marginRight: 5 }}
										disabled={!loggedIn || !validated}
									>
										Submit FS7
									</button>
								</div>
								<div className="clearfix"></div>
							</>
						) : null}
						{validated && !loading && submitting ? (
							<>
								<h4>You're all done!</h4>
								<p>You've submitted your FS7 for this year!</p>
							</>
						) : null}
					</div>
					<div className="clearfix"></div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		credentials: state.submissionForm?.credentials,
		year: state.submissionForm?.year,
		loading: state.submissionForm?.loadingValidation,
		errors: state.submissionForm?.validationResult?.errors,
		validated: state.submissionForm?.validationResult?.validated,
		loggedIn: state.submissionForm?.credentials,
		submitting: state.submissionForm?.submittingFS7,
		modalStatus: state.submissionForm?.validationModal,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(FSSREPORTACTIONS.openFS7ValidationModal()),
	verifyEIDCredentials: (body) => dispatch(FSSREPORTACTIONS.verifyEIDCredentials(body)),
	openFS7ValidationModal: (year, credentials) => dispatch(FSSREPORTACTIONS.validateFS7({ year, credentials })),
	submitFS7: (year, credentials) => dispatch(FSSREPORTACTIONS.validateFS7({ year, credentials, submit: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModal);
